<zt-header></zt-header>
<main class="flex flex-1 overflow-y-auto">
    <zt-loader></zt-loader>
    <router-outlet></router-outlet>
</main>
<zt-footer></zt-footer>
<p-toast position="bottom-right"></p-toast>
